var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "KModal",
    {
      attrs: { title: _vm.$tr("syncAllFacilityDataHeader") },
      on: {
        submit: _vm.handleSubmit,
        cancel: function ($event) {
          return _vm.$emit("cancel")
        },
      },
      scopedSlots: _vm._u([
        {
          key: "actions",
          fn: function () {
            return [
              _c(
                "KButtonGroup",
                [
                  _c("KButton", {
                    attrs: { text: _vm.coreString("cancelAction") },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("cancel")
                      },
                    },
                  }),
                  _c(
                    "span",
                    { ref: "syncbutton" },
                    [
                      _c("KButton", {
                        attrs: {
                          text: _vm.coreString("syncAction"),
                          primary: "",
                          type: "submit",
                          disabled: !_vm.isConnected,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c("p", [_vm._v("\n    " + _vm._s(_vm.$tr("syncExplanation")) + "\n  ")]),
      !_vm.isConnected
        ? _c("p", [
            _vm._v(
              "\n    " + _vm._s(_vm.$tr("mustBeConnectedToInternet")) + "\n  "
            ),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }